<div class="stop-scroll fixed z-50 inset-0 bg-black/60" (click)="closed.emit()">
  <div class="absolute inset-0 overflow-y-auto">
    <div class="flex min-h-full items-start justify-center p-4 sm:p-8 pointer-events-none">
      <div
        class="w-full max-w-7xl my-auto rounded-2xl overflow-hidden shadow-2xl pointer-events-auto"
        (click)="$event.stopPropagation()"
      >

        <!-- ── Header ───────────────────────────────────────────────────── -->
        <div class="bg-[#274693] px-8 py-6 flex items-center justify-between">
          <h3 class="text-white font-semibold tracking-[0.15em] uppercase flex items-center gap-2.5 m-0">
            Analytics
            @if (loading() || refreshing()) {
              <span class="w-3.5 h-3.5 border border-white/30 border-t-white rounded-full animate-spin"></span>
            }
          </h3>
          <button
            (click)="closed.emit()"
            class="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M18 6 6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- ── Body ─────────────────────────────────────────────────────── -->
        <div class="bg-white">

          @if (loading()) {
            <div class="flex items-center justify-center py-32">
              <div class="w-10 h-10 border-2 border-[#0ab2d7] border-t-transparent rounded-full animate-spin"></div>
            </div>

          } @else if (err() && !data()) {
            <div class="flex flex-col items-center justify-center py-28 gap-5">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-neutral-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
              </svg>
              <p class="text-neutral-400 text-sm">Erreur lors du chargement des données</p>
              <button (click)="load()" class="text-sm font-semibold text-[#0ab2d7] border border-[#0ab2d7] px-5 py-2 rounded-full hover:bg-[#0ab2d7] hover:text-white transition-all">
                Réessayer
              </button>
            </div>

          } @else {
            <div class="p-8 flex flex-col gap-6">

              <!-- ── Stat cards ─────────────────────────────────────────── -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-5">

                <div class="group border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-[#0ab2d7]/40 hover:shadow-lg hover:-translate-y-0.5">
                  <div class="flex items-start justify-between gap-2 mb-4">
                    <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest leading-snug m-0">Nombre de traitements</h4>
                    <button (click)="load()" class="shrink-0 text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                      </svg>
                    </button>
                  </div>
                  <p class="text-5xl text-[#0ab2d7] tabular-nums transition-colors duration-200 group-hover:text-[#0099bb]" style="font-family: 'Helvetica LT', sans-serif; font-weight: 900;">{{ data()?.totalProcesses ?? 0 }}</p>
                </div>

                <div class="group border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-[#0ab2d7]/40 hover:shadow-lg hover:-translate-y-0.5">
                  <div class="flex items-start justify-between gap-2 mb-4">
                    <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest leading-snug m-0">Fichiers avec erreurs</h4>
                    <button (click)="load()" class="shrink-0 text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                      </svg>
                    </button>
                  </div>
                  <p class="text-5xl text-[#0ab2d7] tabular-nums transition-colors duration-200 group-hover:text-[#0099bb]" style="font-family: 'Helvetica LT', sans-serif; font-weight: 900;">{{ data()?.filesWithErrors ?? 0 }}</p>
                </div>

                <div class="group border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-[#0ab2d7]/40 hover:shadow-lg hover:-translate-y-0.5">
                  <div class="flex items-start justify-between gap-2 mb-4">
                    <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest leading-snug m-0">Nombre d'erreur par fichier</h4>
                    <button (click)="load()" class="shrink-0 text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                      </svg>
                    </button>
                  </div>
                  <p class="text-5xl text-[#0ab2d7] tabular-nums transition-colors duration-200 group-hover:text-[#0099bb]" style="font-family: 'Helvetica LT', sans-serif; font-weight: 900;">{{ data()?.meanErrorsByFile ?? 0 }}</p>
                </div>

              </div>

              <!-- ── Pie charts ──────────────────────────────────────────── -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">

                <!-- Type de fichiers -->
                <div class="border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-neutral-200 hover:shadow-sm">
                  <div class="flex items-center justify-between mb-6">
                    <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest m-0">Type de fichiers</h4>
                    <button (click)="load()" class="text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                      </svg>
                    </button>
                  </div>
                  @if (!data()?.byDescription?.length) {
                    <div class="flex items-center justify-center h-40 text-neutral-300 text-sm">Pas de données</div>
                  } @else {
                    <canvas #pieExtCanvas></canvas>
                  }
                </div>

                <!-- Distribution des erreurs -->
                <div class="border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-neutral-200 hover:shadow-sm">
                  <div class="flex items-center justify-between mb-6">
                    <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest m-0">Distribution des erreurs</h4>
                    <button (click)="load()" class="text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                      </svg>
                    </button>
                  </div>
                  @if (!data()?.errorDistribution?.length) {
                    <div class="flex items-center justify-center h-40 text-neutral-300 text-sm">Pas de données</div>
                  } @else {
                    <canvas #pieErrCanvas></canvas>
                  }
                </div>

              </div>

              <!-- ── Line chart ──────────────────────────────────────────── -->
              <div class="border border-neutral-100 rounded-xl p-7 transition-all duration-200 hover:border-neutral-200 hover:shadow-sm">
                <div class="flex items-center justify-between mb-6">
                  <h4 class="text-xs font-semibold text-neutral-500 uppercase tracking-widest m-0">Traitements cumulés</h4>
                  <button (click)="load()" class="text-neutral-300 hover:text-[#0ab2d7] transition-colors [&>svg]:transition-transform [&>svg]:duration-500 hover:[&>svg]:rotate-180">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
                      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>
                    </svg>
                  </button>
                </div>
                @if ((data()?.dailyData?.length ?? 0) < 2) {
                  <div class="flex items-center justify-center h-36 text-neutral-300 text-sm">Pas assez de données</div>
                } @else {
                  <canvas #lineCanvas></canvas>
                }
              </div>

            </div>
          }
        </div>

      </div>
    </div>
  </div>
</div>
